import React, { useState } from "react";
import styles from "../components/css/ReusableCollapse.module.css";
import { motion } from "framer-motion";

import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";

const ReusableCollapse = ({
  header = "Header",
  children = "Children",
  handleEdit,
}) => {
  const [collapse, setCollapse] = useState(false);

  const handleClick = () => {
    setCollapse((pre) => !pre);
  };
  //   const handleEdit = (e) => {
  //     e.stopPropagation(); // ✅ correct spelling
  //     console.log("click");
  //   };

  return (
    <div
      className={styles.collapseCon}
      // onMouseEnter={handleClick}
      // onMouseLeave={handleClick}
      onClick={handleClick}
    >
      <div className={styles.header}>
        {header}
        <div>
          <IoMdArrowDropdown 
            className={`${styles.arrow} ${
              collapse ? styles.open : styles.close
            }`}
          />
        </div>
      </div>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={
          collapse
            ? { height: "fit-content", opacity: 1 }
            : { height: 0, opacity: 0 }
        }
        transition={{ duration: 0.3, ease: "easeIn" }}
        className={styles.body}
      >
        <div className={styles.children}>{children}</div>
      </motion.div>
    </div>
  );
};

export default ReusableCollapse;
